import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';

const noteTitle = (props) => {
  return (
    <div className='note-title'>
      <Image src={require('./images/note.svg')} alt='תמונה צליל' />
      <p>{props.text}</p>
    </div>
  );
};

export default noteTitle;
